const updateFunc = (controlData) => {
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;

  const h = 1000 - prevalence;
  const fp = 100 - specificity;
  const tn = specificity;
  const fpr = fp / 100;
  const tnr = tn / 100;
  const afp = fpr * h;
  const atn = tnr * h;

  const jsonTrueNegativeActual = { Status: "True negative" };
  const jsonFalsePositiveActual = { Status: "False positive" };
  const jsonRemaining = { Status: "." };
  const repeatedTrueNegativeActual = Array(Math.round(atn)).fill(
    jsonTrueNegativeActual
  );
  const repeatedFalsePositiveActual = Array(Math.round(afp)).fill(
    jsonFalsePositiveActual
  );
  const repeatedRemaining = Array(Math.round(1000 - atn - afp)).fill(
    jsonRemaining
  );
  let calculatedData = repeatedTrueNegativeActual.concat(
    repeatedFalsePositiveActual
  );
  calculatedData = calculatedData.concat(repeatedRemaining);

  return calculatedData;
};

export default updateFunc;
